<template>
  <div>
    <div class="text-center" v-if="loading">
      <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
    <h2>Modificación a tarifas base municipios</h2>
    <div class="card">
      <div class="card-body">
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-9">
              <a-form-item label="Geocerca">
                <v-select label="name" :options="getAllGeofences" v-model="$v.fare.geofenceId.$model"  @input="consultGeoFares($event)"><span slot="no-options">Elemento no encontrado</span></v-select>
                <small class="text-danger" v-if="!$v.fare.geofenceId.required">Campo requerido. No debe estar vacío.</small>
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Porcentaje de comisión por uso de aplicación">
                <a-input
                  placeholder="Porcentaje de comisión por uso de aplicación"
                  v-model="$v.fare.appCharge.$model"
                >
                 <a-icon slot="addonAfter" type="percentage" />
                </a-input>
                <small class="text-danger" v-if="!$v.fare.appCharge.required">Campo requerido. No debe estar vacío</small>
                <small class="text-danger" v-if="!$v.fare.appCharge.numeric || parseInt($v.fare.appCharge.$model) < 0">Ingresa un valor entero positivo</small>
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Costo de banderazo">
                <a-input
                  placeholder="Costo de banderazo"
                  v-model="$v.fare.startedPrice.$model"
                >
                 <a-icon slot="addonBefore" type="dollar" />
                </a-input>
                <small class="text-danger" v-if="!$v.fare.startedPrice.required">Campo requerido. No debe estar vacío</small>
                <small class="text-danger" v-if="!$v.fare.startedPrice.decimal">Campo decimal</small>
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Costo por tiempo">
                <a-input
                  placeholder="Costo por tiempo"
                  v-model="$v.fare.timeFare.$model"
                >
                <a-icon slot="addonBefore" type="dollar" />
                </a-input>
                <small class="text-danger" v-if="!$v.fare.timeFare.required">Campo requerido. No debe estar vacío</small>
                <small class="text-danger" v-if="!$v.fare.timeFare.decimal">Campo decimal</small>
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <a-form-item label="Costo por distancia 1">
                <a-input
                  placeholder="Costo por distancia 1"
                  v-model="$v.fare.chargeShortFare.$model"
                >
                <a-icon slot="addonBefore" type="dollar" />
                </a-input>
                <small class="text-danger" v-if="!$v.fare.chargeShortFare.required">Campo requerido. No debe estar vacío</small>
                <small class="text-danger" v-if="!$v.fare.chargeShortFare.decimal">Campo decimal</small>
              </a-form-item>
            </div>
            <div class="col-md-2">
              <a-form-item label="Costo por distancia 2">
                <a-input
                  placeholder="Costo por distancia 2"
                  v-model="$v.fare.chargeLargeFare.$model"
                >
                <a-icon slot="addonBefore" type="dollar" />
                </a-input>
                <small class="text-danger" v-if="!$v.fare.chargeLargeFare.required">Campo requerido. No debe estar vacío</small>
                <small class="text-danger" v-if="!$v.fare.chargeLargeFare.decimal">Campo decimal</small>
              </a-form-item>
            </div>
            <div class="col-md-8">
              <a-form-item label="Porcentaje de tarifa nocturna">
                <a-input
                  placeholder="Porcentaje de tarifa nocturna"
                  v-model="$v.fare.nightFare.$model"
                >
                <a-icon slot="addonAfter" type="percentage" />
                </a-input>
                <small class="text-danger" v-if="!$v.fare.nightFare.required">Campo requerido. No debe estar vacío</small>
                <small class="text-danger" v-if="!$v.fare.nightFare.numeric || parseInt($v.fare.nightFare.$model) < 0">Ingresa un valor entero positivo</small>
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Velocidad de transferencia">
                <a-input
                  placeholder="Velocidad de transferencia"
                  v-model="$v.fare.transferSpeed.$model"
                >
                </a-input>
                <small class="text-danger" v-if="!$v.fare.transferSpeed.required">Campo requerido. No debe estar vacío</small>
                <small class="text-danger" v-if="!$v.fare.transferSpeed.decimal || parseInt($v.fare.transferSpeed.$model) < 0">Ingresa un valor entero positivo</small>
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Rango banderazo">
                <a-input
                  placeholder="Rango banderazo (km)"
                  v-model="$v.fare.distanceStartedPrice.$model"
                >
                </a-input>
                <small class="text-danger" v-if="!$v.fare.distanceStartedPrice.required">Campo requerido. No debe estar vacío</small> <br>
                <small class="text-danger" v-if="!$v.fare.distanceStartedPrice.decimal">Campo decimal</small>
                <small class="text-danger" v-if="!$v.fare.distanceStartedPrice.required || parseFloat($v.fare.distanceStartedPrice.$model) > parseFloat($v.fare.distanceShortFare.$model)">Ingrese un valor igual o menor al Rango de distancia 1</small>
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Rango de distancia 1">
                <a-input
                  placeholder="Rango de distancia 1 (km)"
                  v-model="$v.fare.distanceShortFare.$model"
                >
                </a-input>
                <small class="text-danger" v-if="!$v.fare.distanceShortFare.required">Campo requerido. No debe estar vacío</small> <br>
                <small class="text-danger" v-if="!$v.fare.distanceShortFare.decimal">Campo decimal</small>
                <small class="text-danger" v-if="!$v.fare.distanceShortFare.required || parseFloat($v.fare.distanceShortFare.$model) < parseFloat($v.fare.distanceStartedPrice.$model)">Ingresa un valor igual o mayor al Rango banderazo</small>
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <a-form-item>
                <b-button
                  :disabled="!(parseFloat($v.fare.distanceShortFare.$model) >= parseFloat($v.fare.distanceStartedPrice.$model) && parseFloat($v.fare.distanceStartedPrice.$model) <= parseFloat($v.fare.distanceShortFare.$model) && !$v.$invalid )"
                  block
                  type="submit"
                  class="btn px-5"
                >
                  Registrar
                </b-button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
    <div>
      <h1>Historial de modificaciones a tarifa base municipios </h1>
      <b-row>
        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" class="form-control" placeholder="Buscar"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="3" label="Registros por página" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
          </b-form-group>
        </b-col>
        <b-table
            show-empty
            stacked="md"
            :items="getTownFaresByGeofenceId"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered"
            empty-text="No existen registros por mostrar"
            emptyFilteredText="No existen registros por mostrar"
          >
          <template v-slot:cell(appCharge)="row">
            {{ (row.item.appCharge * 100).toFixed(0) + ' %' }}
          </template>
          <template v-slot:cell(nightFare)="row">
            {{ (row.item.nightFare * 100).toFixed(0) + ' %' }}
          </template>
          <template v-slot:cell(timeFare)="row">
            {{ '$' + row.item.timeFare }}
          </template>
          <template v-slot:cell(startedPrice)="row">
            {{ '$' + row.item.startedPrice }}
          </template>
          <template v-slot:cell(chargeShortFare)="row">
            {{ '$' + row.item.chargeShortFare }}
          </template>
          <template v-slot:cell(chargeLargeFare)="row">
            {{ '$' + row.item.chargeLargeFare + ' '}}
          </template>
          <template v-slot:cell(transferSpeed)="row">
            {{ row.item.transferSpeed +  ' km/h'}}
          </template>
          <template v-slot:cell(distanceStartedPrice)="row">
            {{ row.item.distanceStartedPrice +  ' km'}}
          </template>
          <template v-slot:cell(distanceShortFare)="row">
            {{ row.item.distanceShortFare +  ' km'}}
          </template>
          </b-table>
          <b-row>
            <b-col md="6" class="my-1">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
      </b-row>
      <div class="text-center" v-if="loading">
        <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
      </div>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import { required, numeric, decimal } from 'vuelidate/lib/validators'
import headers from '@/config/headers.js'
import moment from 'moment'
const CREATE_FARE = gql`
  mutation createTownFare(
    $appCharge: Float, 
    $startedPrice: Float, 
    $distanceStartedPrice: Float, 
    $distanceShortFare: Float, 
    $nightFare: Float, 
    $timeFare: Float, 
    $transferSpeed: Float, 
    $chargeShortFare: Float, 
    $chargeLargeFare: Float, 
    $createdBy: String, 
    $active: Int, 
    $geofenceId: Int){
    createTownFare(fare: { 
      appCharge: $appCharge, 
      startedPrice: $startedPrice, 
      distanceStartedPrice: $distanceStartedPrice, 
      distanceShortFare: $distanceShortFare, 
      nightFare: $nightFare, 
      timeFare: $timeFare, 
      transferSpeed: $transferSpeed, 
      chargeShortFare: $chargeShortFare, 
      chargeLargeFare: $chargeLargeFare, 
      createdBy: $createdBy, 
      active: $active, 
      geofenceId: $geofenceId }){
      createdBy
      startedPrice
    }
  }
`
const UPDATE_FARE = gql`
  mutation updateTownFare(
    $fareId: Int,
    $appCharge: Float, 
    $startedPrice: Float, 
    $distanceStartedPrice: Float, 
    $distanceShortFare: Float, 
    $nightFare: Float, 
    $timeFare: Float, 
    $transferSpeed: Float, 
    $chargeShortFare: Float, 
    $chargeLargeFare: Float, 
    $updatedBy: String, 
    $active: Int, 
    $geofenceId: Int){
    updateTownFare(fareId: $fareId, fareRequest: { 
      appCharge: $appCharge, 
      startedPrice: $startedPrice, 
      distanceStartedPrice: $distanceStartedPrice, 
      distanceShortFare: $distanceShortFare, 
      nightFare: $nightFare, 
      timeFare: $timeFare, 
      transferSpeed: $transferSpeed, 
      chargeShortFare: $chargeShortFare, 
      chargeLargeFare: $chargeLargeFare, 
      updatedBy: $updatedBy, 
      active: $active, 
      geofenceId: $geofenceId }){
      updatedBy
      startedPrice
    }
  }
`
const GET_FARES_BY_GEOFENCE = gql`
  query getTownFaresByGeofenceId(
    $geofenceId: Int){
      getTownFaresByGeofenceId(
        geofenceId: $geofenceId){
        id
        appCharge
        startedPrice
        distanceStartedPrice
        timeFare
        transferSpeed
        distanceShortFare
        chargeShortFare
        chargeLargeFare
        nightFare
        createdAt
        updatedAt
        createdBy
        updatedBy
        active
      }
  }
`
const GET_FARES_BY_ID = gql`
  query getFareHistoryTownByFareId(
    $fareId: Int){
      getFareHistoryTownByFareId(
        fareId: $fareId){
        id
        date
        appCharge
        startedPrice
        distanceStartedPrice
        timeFare
        transferSpeed
        distanceShortFare
        chargeShortFare
        chargeLargeFare
        nightFare
        createdAt
        createdBy
      }
  }
`
const GET_GEOCERCAS = gql`
  query getAllGeofences{
    getAllGeofences{
      id
      name
    }
  }
`
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      disabledButton: false,
      fareid: 0,
      // idSel: 0,
      fareByGeo: false,
      fare: {
        appCharge: '',
        startedPrice: '',
        timeFare: '',
        distanceShortFare: '',
        // distanceLongFare: '',
        distanceStartedPrice: '',
        nightFare: '',
        transferSpeed: '',
        chargeShortFare: '',
        chargeLargeFare: '',
        active: '1',
        geofenceId: '',
        key: 0,
      },
      // tabla
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      // sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      // idSel: this.fareId,
      getTownFaresByGeofenceId: [],
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'date', label: 'Fecha' },
        { key: 'createdBy', label: 'Responsable' },
        { key: 'appCharge', label: 'Comisión por uso de aplicación' },
        { key: 'startedPrice', label: 'Costo de banderazo' },
        { key: 'timeFare', label: 'Costo por tiempo' },
        { key: 'chargeShortFare', label: 'Costo por distancia 1' },
        { key: 'chargeLargeFare', label: 'Costo por distancia 2' },
        { key: 'transferSpeed', label: 'Velocidad de transferencia' },
        { key: 'nightFare', label: 'Porcentaje de tarifa nocturna' },
        { key: 'distanceStartedPrice', label: 'Rango banderazo' },
        { key: 'distanceShortFare', label: 'Rango de distancia 1' },
      ],
    }
  },
  apollo: {
    getAllGeofences: {
      query: GET_GEOCERCAS,
      result({ data }) {
        console.log(data)
      },
      error(error) {
        console.log(error)
      },
      context: headers(),
    },
  },
  methods: {
    moment,
    consultGeoFares(geo) {
      console.log(geo, 'algo')
      this.$apollo.query({
        query: GET_FARES_BY_GEOFENCE,
        variables: {
          geofenceId: geo.id,
        },
        context: headers(),
      })
        .then(data => {
          this.loading = false
          console.log(data, 'data')
          console.log(data.data.getTownFaresByGeofenceId, 'datageo')
          if (data.data.getTownFaresByGeofenceId.appCharge === null) {
            this.fareByGeo = false
            this.getTownFaresByGeofenceId = []
            this.fareid = ''
            this.fare.appCharge = ''
            this.fare.startedPrice = ''
            this.fare.timeFare = ''
            this.fare.distanceShortFare = ''
            this.fare.distanceStartedPrice = ''
            this.fare.nightFare = ''
            this.fare.transferSpeed = ''
            this.fare.chargeShortFare = ''
            this.fare.chargeLargeFare = ''
          } else {
            console.log(data.data.getTownFaresByGeofenceId.appCharge, '0')
            this.fareByGeo = true
            this.fareid = data.data.getTownFaresByGeofenceId.id
            this.consultIdFares(data.data.getTownFaresByGeofenceId.id)
            this.fare.appCharge = (data.data.getTownFaresByGeofenceId.appCharge * 100).toFixed(0)
            this.fare.startedPrice = data.data.getTownFaresByGeofenceId.startedPrice
            this.fare.timeFare = data.data.getTownFaresByGeofenceId.timeFare
            this.fare.distanceShortFare = data.data.getTownFaresByGeofenceId.distanceShortFare
            this.fare.distanceStartedPrice = data.data.getTownFaresByGeofenceId.distanceStartedPrice
            this.fare.nightFare = (data.data.getTownFaresByGeofenceId.nightFare * 100).toFixed(0)
            this.fare.transferSpeed = data.data.getTownFaresByGeofenceId.transferSpeed
            this.fare.chargeShortFare = data.data.getTownFaresByGeofenceId.chargeShortFare
            this.fare.chargeLargeFare = data.data.getTownFaresByGeofenceId.chargeLargeFare
          }
          // this.fare.appCharge = data.getTownFaresByGeofenceId.appCharge
          // this.$router.push('/montos/crearTarifa')
          // this.$refs.listComponent.refetchQuery()
          // this.$refs.listComponent.showComponent()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    },
    consultIdFares(id) {
      this.$apollo.query({
        query: GET_FARES_BY_ID,
        variables: {
          fareId: id,
        },
        context: headers(),
      })
        .then(data => {
          console.log(data.data.getFareHistoryTownByFareId, 'dataid')
          this.loading = false
          this.getTownFaresByGeofenceId = data.data.getFareHistoryTownByFareId
          this.totalRows = data.data.getFareHistoryTownByFareId.length
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    },
    addTimeRange() {
      if (this.startHour < this.endHour) {
        this.fare.timeRange.add({ startHour: this.startHour, endHour: this.endHour })
      }
      console.log(this.fare.timeRange)
    },
    onChangeStartHour1(time, timeString) {
      this.fare.startHour1 = timeString
      if (this.fare.startHour1 < this.fare.endHour1) {
        console.log('greater')
        console.log(time, timeString)
      } else {
        console.log(this.fare.startHour1, this.fare.endHour1)
      }
    },
    onChangeEndHour1(time, timeString) {
      this.fare.endHour1 = timeString
      if (this.fare.startHour1 < this.fare.endHour1) {
        console.log('greater')
        console.log(time, timeString)
      } else {
        console.log(this.fare.startHour1, this.fare.endHour1)
      }
    },
    onChangeStartHour2(time, timeString) {
      this.fare.startHour2 = timeString
      if (this.fare.startHour2 < this.fare.endHour2) {
        console.log('greater')
        console.log(time, timeString)
      } else {
        console.log(this.fare.startHour2, this.fare.endHour2)
      }
    },
    onChangeEndHour2(time, timeString) {
      this.fare.endHour2 = timeString
      if (this.fare.startHour2 < this.fare.endHour2) {
        console.log('greater')
        console.log(time, timeString)
      } else {
        console.log(this.fare.startHour2, this.fare.endHour2)
      }
    },
    // redondear (val) {
    //   val = Math.round(val * 10) / 10
    //   var xsd = val.toString().split('.')
    //   if (xsd.length === 1) {
    //     val = val.toString() + '.00'
    //     return val
    //   }
    //   return val
    // },
    handleSubmit() {
      this.loading = true
      const fareData = { ...this.fare }
      console.log(fareData, 'faredata')
      var conversion = parseFloat(fareData.transferSpeed)
      this.clearForm()
      if (this.fareByGeo === false) {
        this.$apollo.mutate({
          mutation: CREATE_FARE,
          variables: {
            createdBy: this.$store.state.user.email,
            appCharge: parseInt(fareData.appCharge) / 100,
            distanceStartedPrice: parseFloat(fareData.distanceStartedPrice),
            transferSpeed: parseFloat(conversion),
            chargeShortFare: parseFloat(fareData.chargeShortFare),
            chargeLargeFare: parseFloat(fareData.chargeLargeFare),
            active: parseInt(fareData.active),
            geofenceId: parseInt(fareData.geofenceId.id),
            startedPrice: parseFloat(fareData.startedPrice),
            distanceShortFare: parseFloat(fareData.distanceShortFare),
            nightFare: parseInt(fareData.nightFare) / 100,
            timeFare: parseFloat(fareData.timeFare),
          },
          context: headers(),
        })
          .then(data => {
            this.loading = false
            // this.$router.push('/montos/crearTarifa')
            // this.$refs.listComponent.refetchQuery()
            // this.$refs.listComponent.showComponent()
          })
          .catch(err => {
            this.loading = false
            console.log(err)
          })
      } else {
        this.$apollo.mutate({
          mutation: UPDATE_FARE,
          variables: {
            fareId: this.fareid,
            updatedBy: this.$store.state.user.email,
            appCharge: parseInt(fareData.appCharge) / 100,
            distanceStartedPrice: parseFloat(fareData.distanceStartedPrice),
            transferSpeed: parseFloat(conversion),
            chargeShortFare: parseFloat(fareData.chargeShortFare),
            chargeLargeFare: parseFloat(fareData.chargeLargeFare),
            active: parseInt(fareData.active),
            geofenceId: parseInt(fareData.geofenceId.id),
            startedPrice: parseFloat(fareData.startedPrice),
            distanceShortFare: parseFloat(fareData.distanceShortFare),
            nightFare: parseInt(fareData.nightFare) / 100,
            timeFare: parseFloat(fareData.timeFare),
          },
          context: headers(),
        })
          .then(data => {
            this.loading = false
            this.getTownFaresByGeofenceId = []
            // this.$router.push('/montos/crearTarifa')
            // this.$refs.listComponent.refetchQuery()
            // this.$refs.listComponent.showComponent()
          })
          .catch(err => {
            this.loading = false
            console.log(err)
          })
      }
    },
    clearForm() {
      this.fare.appCharge = ''
      this.fare.startedPrice = ''
      this.fare.timeFare = ''
      this.fare.distanceShortFare = ''
      // this.fare.distanceLongFare = ''
      this.fare.nightFare = ''
      this.fare.transferSpeed = ''
      this.fare.geofenceId = ''
      this.fare.chargeShortFare = ''
      this.fare.chargeLargeFare = ''
      this.fare.distanceStartedPrice = ''
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
  validations: {
    fare: {
      appCharge: { required, numeric },
      startedPrice: { required, decimal },
      timeFare: { required, decimal },
      distanceShortFare: { required, decimal },
      transferSpeed: { required, decimal },
      geofenceId: { required },
      chargeShortFare: { required, decimal },
      chargeLargeFare: { required, decimal },
      distanceStartedPrice: { required, decimal },
      // rushHourCharge: { required, decimal },
      // distanceLongFare: { required, decimal },
      nightFare: { required, numeric },
      // startHour1: { required },
      // endHour1: { required },
      // startHour2: { required },
      // endHour2: { required },
    },
  },
}
</script>
